import React from 'react';
import { Table, Button } from 'react-bootstrap';
import './workflow-reports.scss';

const WorkflowReports = ({ reports }) => {
  const handleApprove = (id) => {
    console.log('Approving report with ID:', id);
    // Add logic to handle report approval
  };

  const handleReject = (id) => {
    console.log('Rejecting report with ID:', id);
    // Add logic to handle report rejection
  };

  return (
    <div className='reportType-table'>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ISIN</th>
            <th>Next Interest Payment Date</th>
            <th>BP ID</th>
            <th>Status</th>
            <th>Issuer Decision</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 ? (
            <tr>
              <td colSpan="5">No Reports Available</td>
            </tr>
          ) : (
            reports.map(report => (
              <tr key={report.id}>
                <td>{report.isin}</td>
                <td>{report.nextInterestDate}</td>
                <td>{report.bpId}</td>
                <td>{report.status}</td>
                <td>
                  {report.status === 'For Issuer Review' ? (
                    <div>
                      <Button variant="success" onClick={() => handleApprove(report.id)} className="mr-2">
                        Approve
                      </Button>
                      <Button variant="danger" onClick={() => handleReject(report.id)}>
                        Reject
                      </Button>
                    </div>
                  ) : (
                    ''
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default WorkflowReports;
